import { ApiClient } from '../../../shared/api/ApiClient';

export interface Consignment {
  id: string;
  shopId: string;
  shopifyOrderId: string;
  shopifyOrderName: string | null;
  tntConsignmentNumber: string | null;
  status: string;
  labelUrl: string | null;
  createdAt: string;
  updatedAt: string;
  lastPolledAt: string | null;
  _count?: { trackingEvents: number };
}

export interface TrackingEvent {
  id: string;
  consignmentId: string;
  status: string;
  description: string | null;
  occurredAt: string;
  rawPayload: unknown;
  createdAt: string;
}

export interface ConsignmentDetail extends Consignment {
  trackingEvents: TrackingEvent[];
  shop: { id: string; domain: string };
}

export interface ListParams {
  cursor?: string;
  limit?: number;
  status?: string;
}

export interface ListResponse {
  items: Consignment[];
  nextCursor: string | null;
}

export function listConsignments(
  api: ApiClient,
  params: ListParams = {},
): Promise<ListResponse> {
  const q = new URLSearchParams();
  if (params.cursor) q.set('cursor', params.cursor);
  if (params.limit) q.set('limit', String(params.limit));
  if (params.status) q.set('status', params.status);
  const qs = q.toString();
  return api.get<ListResponse>(`/admin/api/consignments${qs ? `?${qs}` : ''}`);
}

export function getConsignment(api: ApiClient, id: string): Promise<ConsignmentDetail> {
  return api.get<ConsignmentDetail>(`/admin/api/consignments/${id}`);
}
